import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import zoneApi from './ZoneApi';
import { zoneActions } from './ZoneSlice';
import { HTTP_RESPONSE_STATUS } from '../../../../../setup/constants/Http';
import { ToastDefaultConfig } from '../../../../../setup/toast/ToastConfig';
import { GetZoneRequest, ZoneListResponse, ZoneResponse, HousingResponse, GetHousingRequest, ProvinceSearchRequest, ProvinceSearchResponse } from '../models';
import { ResponseArray, ListResponse, Response } from '../../../../../setup/axios/HttpResponse';

function* fetchProvinceList(action: PayloadAction<ProvinceSearchRequest>): Generator<any, void, any> {
  try {
    const response: Response<ProvinceSearchResponse> = yield call(zoneApi.getProvince, action.payload);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      yield put(zoneActions.fetchProvinceListSuccess(response.data.rows));
    } else {
      toast.error(response.message || 'Failed to fetch province list', ToastDefaultConfig());
      yield put(zoneActions.fetchProvinceListFailed(response.message || 'Failed to fetch province list'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch province list', ToastDefaultConfig());
    yield put(zoneActions.fetchProvinceListFailed(error.message || 'Failed to fetch province list'));
  }
}

function* fetchHousingList(action: PayloadAction<GetHousingRequest>): Generator<any, void, any> {
  try {
    const response: ResponseArray<HousingResponse> = yield call(zoneApi.getHousing, action.payload.provinceIds);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      yield put(zoneActions.fetchHousingListSuccess(response.data));
    } else {
      toast.error(response.message || 'Failed to fetch housing list', ToastDefaultConfig());
      yield put(zoneActions.fetchHousingListFailed(response.message || 'Failed to fetch housing list'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch housing list', ToastDefaultConfig());
    yield put(zoneActions.fetchHousingListFailed(error.message || 'Failed to fetch housing list'));
  }
}

function* fetchZoneList(action: PayloadAction<GetZoneRequest>): Generator<any, void, any> {
  try {
    const response: ListResponse<ZoneResponse> = yield call(zoneApi.getZone, action.payload);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      const transformedResponse: ZoneListResponse = {
        data: response.data.rows || [],
        total: response.data.pagination?.totalRows || 0,
      };
      yield put(zoneActions.fetchZoneListSuccess(transformedResponse));
    } else {
      toast.error(response.message || 'Failed to fetch zone list', ToastDefaultConfig());
      yield put(zoneActions.fetchZoneListFailed(response.message || 'Failed to fetch zone list'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch zone list', ToastDefaultConfig());
    yield put(zoneActions.fetchZoneListFailed(error.message || 'Failed to fetch zone list'));
  }
}

export function* zoneSaga() {
  yield takeLatest(zoneActions.fetchProvinceListStart.type, fetchProvinceList);
  yield takeLatest(zoneActions.fetchHousingListStart.type, fetchHousingList);
  yield takeLatest(zoneActions.fetchZoneListStart.type, fetchZoneList);
}

export default zoneSaga;

